import { EventLocationsState } from ".";
import {
  EventLocations,
  EventMapLocations,
} from "../../interfaces/eventLocations";

type EventLocationsActionType =
  | {
      type:
        | "[Locations] - SetEventLocations"
        | "[Locations] - ClearEventLocations";

      payload: EventLocationsState;
    }
  | {
      type: "[Locations] - SetMapEventLocations";
      payload: EventMapLocations[];
    };

export const EventlocationsReducer = (
  state: EventLocationsState,
  action: EventLocationsActionType
): EventLocationsState => {
  switch (action.type) {
    case "[Locations] - SetEventLocations":
      return {
        ...state,
        ...action.payload,
      };
    case "[Locations] - SetMapEventLocations":
      return {
        ...state,
        ...action.payload,
      };
    case "[Locations] - ClearEventLocations":
      return action.payload;
    default:
      return state;
  }
};
